export default {
  editMode: {
    status: false,
    roleId: null,
    type: null,
    rights: [],
  },
  account: {
    rights: [],
    roles: [],
  },
  project: {
    rights: [],
    roles: [],
  },
};
